import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class TranscriptTemplate extends ApplicationRecord {
  static jsonapiType = "transcript_templates";

  @Attr() exampleFilename: string;

  @Attr() exampleUrl: string;

  @Attr() filename: string;

  @Attr() name: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() styleGuide: string;

  @Attr() url: string;
}

export default TranscriptTemplate;
